import { PythonTopicExercise } from '../../../../types/python-topic';

export const fechasCarpetasExercises: PythonTopicExercise[] = [
  {
    id: 1,
    title: 'Trabajar con fechas',
    description: 'Aprende a trabajar con fechas usando el módulo datetime de Python.',
    initialCode: `from datetime import datetime, timedelta

# Obtén la fecha y hora actual
ahora = 

# Crea una fecha específica
fecha_nacimiento = datetime(1990, 5, 15)

# Calcula la diferencia de días
dias_desde_nacimiento = 

print(f"Fecha actual: {ahora}")
print(f"Días desde nacimiento: {dias_desde_nacimiento}")`,
    solution: `from datetime import datetime, timedelta

# Obtén la fecha y hora actual
ahora = datetime.now()

# Crea una fecha específica
fecha_nacimiento = datetime(1990, 5, 15)

# Calcula la diferencia de días
diferencia = ahora - fecha_nacimiento
dias_desde_nacimiento = diferencia.days

print(f"Fecha actual: {ahora}")
print(f"Días desde nacimiento: {dias_desde_nacimiento}")`,
    testCases: [],
    hints: [
      'Usa datetime.now() para fecha actual',
      'datetime(año, mes, día) crea una fecha específica',
      'Resta fechas para obtener diferencia',
      'Usa .days para obtener días de una diferencia'
    ],
    validateOnlyCode: true,
    why: {
      title: '¿Por qué trabajar con fechas?',
      content: `**Trabajar con fechas** es esencial en muchas aplicaciones: sistemas de facturación, calendarios, logs, reportes con fechas, etc.

### ¿Por qué este ejercicio?
- **Aplicación práctica**: Muy común en sistemas reales
- **Cálculos de tiempo**: Diferencia entre fechas, agregar días
- **Formateo**: Mostrar fechas en diferentes formatos
- **Fundamentos**: Base para operaciones más complejas

### En el mundo real:
Cuando un sistema de facturación calcula días de vencimiento, usa datetime para calcular fechas futuras y diferencias. Sin manejo de fechas, tendrías que calcular manualmente días, meses y años.`,
      keyPoints: [
        'datetime.now() obtiene fecha y hora actual',
        'datetime(año, mes, día) crea fechas específicas',
        'Puedes restar fechas para obtener diferencias',
        'timedelta permite agregar o restar tiempo'
      ],
      realWorldExample: 'En un sistema de reservas, calculas la fecha de check-out sumando días a la fecha de check-in usando timedelta.'
    },
    theory: `# Trabajar con Fechas

## Módulo datetime

Python incluye el módulo \`datetime\` para trabajar con fechas y horas.

## Fecha Actual

\`\`\`python
from datetime import datetime
ahora = datetime.now()
\`\`\`

## Crear Fechas Específicas

\`\`\`python
from datetime import datetime
fecha = datetime(2024, 5, 15)  # Año, mes, día
\`\`\`

## Calcular Diferencias

Puedes restar fechas para obtener diferencias:

\`\`\`python
fecha1 = datetime(2024, 1, 1)
fecha2 = datetime(2024, 1, 15)
diferencia = fecha2 - fecha1
dias = diferencia.days  # 14
\`\`\`

## Agregar Tiempo

Usa \`timedelta\` para agregar tiempo:

\`\`\`python
from datetime import datetime, timedelta
fecha = datetime(2024, 1, 1)
futuro = fecha + timedelta(days=30)
\`\`\`

## Ventajas

- **Precisión**: Maneja fechas y horas correctamente
- **Cálculos**: Fácil calcular diferencias y agregar tiempo
- **Formateo**: Múltiples formatos de salida
- **Zonas horarias**: Soporte para zonas horarias`,
    tips: [
      'Importa datetime: from datetime import datetime',
      'datetime.now() obtiene fecha y hora actual',
      'Puedes restar fechas para obtener diferencias',
      'timedelta permite agregar días, horas, etc.',
      'Usa .strftime() para formatear fechas'
    ],
    advice: [
      'Aprende las funciones básicas de datetime',
      'Practica calcular diferencias entre fechas',
      'Considera zonas horarias en aplicaciones globales',
      'El manejo de fechas es esencial en muchas aplicaciones'
    ]
  }
];
